module.exports = {"house_number":"House number","enter_house_number":"Enter house number"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/house.json
// module id = 644
// module chunks = 247 1449